// extracted by mini-css-extract-plugin
module.exports = {"paddingTab":"styles--paddingTab--1ASrm","smallTabWidth":"styles--smallTabWidth--2IqLd","largeTabWidth":"styles--largeTabWidth--jDPUg"};